export function registrationFieldAccess(status) {
    const finalized = ["approved", "rejected"].includes(status);
    return {
        reviewDisabled: finalized,
        exemptionsDisabled: status === "rejected",
        showExemptionSave: status === "approved",
    };
}
